module.exports = __webpack_public_path__ + "static/media/bundle_left_arrow.bec86673.svg";